import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import JobNotfound from "../assets/images/jobNotfound.png"
function NoMoreJobs({text}) {
     return (
          <>
               <div className="jobNotFound-box">
                    <div className="NormoreJobs_inner_box">
                        <img src={JobNotfound} alt="img" />
                       <h4>{text}</h4>
                    </div>
               </div>

          </>
     );
}
export default NoMoreJobs;